/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { DataManagerDataDictionariesPageEntrypointProps } from './DataManagerDataDictionariesPage.entrypoint.types.tsx';

type DataDictionariesEntryPointComponent = EntryPointComponent<
	{},
	{},
	DataManagerDataDictionariesPageEntrypointProps,
	{}
>;

export const dataDictionariesEntryPoint: EntryPoint<DataDictionariesEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<DataDictionariesEntryPointComponent>(
			/* webpackChunkName: "async-cleansing-statistics-page" */ './DataManagerDataDictionariesPage.tsx',
		),
		getPreloadProps: () => ({
			extraProps: {},
		}),
	});
